var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SLP"},[_c('PublicCert',{attrs:{"logo":_vm.Logo7,"type":'jy-slp',"color":'#8760bc'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }